import { createGlobalStyle } from 'styled-components';
import media from 'styles/media';

export const GlobalStyle = createGlobalStyle`

  html, body {
    height: 100%;
    ${media.IE9 ? '' : 'overflow: hidden;'};
  }

  body {
    margin: 0;
    padding: 0;
    font-family: ${props => props.theme.fontFamily};
    font-size: 19px;
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.backgroundColorPrimary};
  }
  
  #root {
    display: flex;
    flex: 1 1 auto;
  }
  
  p {
    margin: 1em 0;
  }

  .react-datepicker-wrapper .react-datepicker__input-container {
    display: flex;
    flex-direction: column;
  }
  
  .react-datepicker__day:focus, .react-datepicker__time-list:focus, .react-datepicker__time-list-item:focus {
    outline: Highlight solid 2px;
    outline: -webkit-focus-ring-color auto 1px;
    transform: translateZ(0);
  }
  
  .react-datepicker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box,
  .react-datepicker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
    width: auto;
    padding: 2px;
  }
`;
